var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.idProtectEligible
        ? _c(
            "v-col",
            {
              staticClass:
                "justify-space-between wrap d-inline-flex align-center",
              attrs: {
                cols: "12"
              }
            },
            [
              _vm.selected_domain.idprotect === 1
                ? _c("v-switch", {
                    on: {
                      change: _vm.switchModalState
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "label",
                          fn: function fn() {
                            return [
                              _c(
                                "div",
                                [
                                  _vm._v(" ID Protect "),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: {
                                        top: ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function fn(_ref) {
                                              var on = _ref.on
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    {
                                                      staticClass: "mb-1",
                                                      attrs: {
                                                        small: ""
                                                      },
                                                      on: {
                                                        click: function click(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                        }
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      "mdi-information-outline"
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2291823170
                                      )
                                    },
                                    [_vm._v(" Hide your information in WHOIS ")]
                                  ),
                                  _vm.selected_domain.cancellation_id
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            top: ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function fn(_ref2) {
                                                  var on = _ref2.on,
                                                    attrs = _ref2.attrs
                                                  return [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        staticClass: "pl-1",
                                                        attrs: {
                                                          to: "/cancellations/".concat(
                                                            _vm.selected_domain
                                                              .cancellation_id
                                                          ),
                                                          "aria-label":
                                                            "View Request"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "orange",
                                                                  small: ""
                                                                }
                                                              },
                                                              "v-icon",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              "mdi-alert-outline"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            447937641
                                          )
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              "Your service will be active until the due date."
                                            )
                                          ]),
                                          _c("div", [
                                            _vm._v(
                                              "Click to view/update your request."
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      696884291
                    ),
                    model: {
                      value: _vm.id_protect,
                      callback: function callback($$v) {
                        _vm.id_protect = $$v
                      },
                      expression: "id_protect"
                    }
                  })
                : _vm._e(),
              _vm.selected_domain.idprotect === 0
                ? _c(
                    "gg-btn",
                    {
                      attrs: {
                        dark: "",
                        color: "green",
                        tile: "",
                        elevation: "0",
                        loading: _vm.loading
                      },
                      on: {
                        click: _vm.switchRequestModalState
                      }
                    },
                    [_vm._v(" Request ID Protect ")]
                  )
                : _vm._e()
            ],
            1
          )
        : _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "caption"
                },
                [_vm._v(" This domain is not eligible for ID Protect. ")]
              ),
              _vm.special_domains
                ? _c(
                    "div",
                    {
                      staticClass: "caption"
                    },
                    [
                      _vm._v(
                        " This domain has registrar enabled WHOIS masking. "
                      )
                    ]
                  )
                : _vm._e()
            ]
          ),
      _vm.idProtectWarning
        ? _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "p",
                {
                  staticClass: "caption",
                  staticStyle: {
                    color: "red"
                  }
                },
                [_vm._v("Your information is not protected.")]
              )
            ]
          )
        : _vm._e(),
      _vm.idProtectEligible
        ? [
            _c("gg-modal", {
              attrs: {
                "is-active": _vm.request_modal
              },
              on: {
                close: _vm.switchRequestModalState
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "toolbar",
                    fn: function fn() {
                      return [_vm._v(" Request ID Protect ")]
                    },
                    proxy: true
                  },
                  {
                    key: "body",
                    fn: function fn() {
                      return [
                        _c("p", [
                          _vm._v(
                            " Enabling ID Protect will hide your registrant contact information from the public WHOIS database. Requesting ID Protect will generate a support ticket for processing by our team. "
                          )
                        ]),
                        _c("v-checkbox", {
                          attrs: {
                            color: "green"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function fn() {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "black--text"
                                      },
                                      [
                                        _vm._v("I confirm the "),
                                        _c("b", [_vm._v("$9.95/year")]),
                                        _vm._v(" cost for ID Protect")
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            2951279074
                          ),
                          model: {
                            value: _vm.idProtectAgreement,
                            callback: function callback($$v) {
                              _vm.idProtectAgreement = $$v
                            },
                            expression: "idProtectAgreement"
                          }
                        }),
                        _c("p", [
                          _vm._v("Would you like to enable ID Protect?")
                        ])
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "actions",
                    fn: function fn() {
                      return [
                        _c(
                          "gg-btn",
                          {
                            attrs: {
                              secondary: ""
                            },
                            on: {
                              click: _vm.switchRequestModalState
                            }
                          },
                          [_vm._v(" Cancel ")]
                        ),
                        _c(
                          "gg-btn",
                          {
                            attrs: {
                              primary: "",
                              disabled: !_vm.idProtectAgreement,
                              loading: _vm.loading
                            },
                            on: {
                              click: _vm.requestProtect
                            }
                          },
                          [_vm._v(" Request ID Protect ")]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                827670066
              )
            })
          ]
        : _vm._e(),
      [
        _c("gg-modal", {
          attrs: {
            "is-active": _vm.switch_modal
          },
          on: {
            close: function close($event) {
              return _vm.switchModalState("cancel")
            }
          },
          scopedSlots: _vm._u([
            {
              key: "toolbar",
              fn: function fn() {
                return [_vm._v(" ID Protect ")]
              },
              proxy: true
            },
            {
              key: "body",
              fn: function fn() {
                return [
                  _vm.id_protect === false
                    ? _c("p", [
                        _vm._v(
                          " Disabling ID Protect will cancel billing for the ID Protect Service Addon. You will not be able to turn ID Protect back on once your cancellation is processed. "
                        )
                      ])
                    : _vm._e(),
                  _vm.id_protect === false
                    ? _c("p", [
                        _vm._v(
                          "Would you like to proceed with cancelling ID Protect?"
                        )
                      ])
                    : _vm._e()
                ]
              },
              proxy: true
            },
            {
              key: "actions",
              fn: function fn() {
                return [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        secondary: "",
                        loading: _vm.loading
                      },
                      on: {
                        click: function click($event) {
                          return _vm.switchModalState("cancel")
                        }
                      }
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        primary: ""
                      },
                      on: {
                        click: _vm.cancelIdProtect
                      }
                    },
                    [_vm._v(" Turn Off ID Protect ")]
                  )
                ]
              },
              proxy: true
            }
          ])
        })
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }